


















































































import { Component, Vue } from 'vue-property-decorator';
import { publish } from '../../../shared/eventbus/eventbus';
import { Events } from '../../../shared/eventbus/events';
import RegionSwitcher from '../../component/footer/RegionSwitcher.vue';
import { FooterLinkStructure } from '../../plugins/configuration/types/configuration';

@Component({
  components: { RegionSwitcher },
})
export default class AppFooter extends Vue {
  name = 'AppFooter';

  groupedFooterBlocks: [string, string[]][] = Object.entries([['company', 'games', 'account', 'gportal', 'language'], ['support']]);

  get footerLinks(): FooterLinkStructure {
    return this.$api.data.footer;
  }

  /**
   * returns a window action which open/creates functionality from the vanilla js side,
   * we are returning a string instead of a callback here to get rid of linting problems
   *
   * @param action
   */
  runFooterAction(action: string): void {
    switch (action) {
      case 'openRecharge':
        // legacy recharge modal
        publish(Events.OpenRechargeModal, {});
        break;
      default:
    }
  }
}
